import usePlatform from '../../hooks/usePlatform';
import { ossPrefix } from './constants';
import './collaboration.scss';

type CollaborationItem = {
  /** 用于拼接图片：ossPrefix + name + .png */
  name: string;
  /** 对应 /aip/product/:productName 路由参数 */
  route: string;
  /** PC 端展示标签 */
  tags?: string[];
  /** PC 端 hover 展示描述 */
  desc?: string;
};

const collaborationItems: CollaborationItem[] = [
  {
    name: '供应商关系',
    route: 'srm',
    tags: ['供应商管理', '寻源管理'],
    desc: '管理供应商关系，评估合作，优化采购协作效率',
  },
  { name: '供应链',
    route: 'supply-chain',
    tags: ['采购', '销售', '库存', '仓库', '送装', '运输'],
    desc: '统筹上下游资源，集中管控全集团采购、销售、库存并执行',
  },
  {
    name: '客户关系',
    route: 'crm',
    tags: ['销售自动化', '渠道商管理'],
    desc: '维护客户与渠道关系，发展渠道，提升客户粘性与复购率',
  },
  {
    name: '商城',
    route: 'ecommerce',
    tags: ['采购商城', '销售商城'],
    desc: '搭建线上交易平台，处理订单、支付及商城运营事宜',
  },
  {
    name: '零售',
    route: 'retail',
    tags: ['全渠道', '促销', '会员', '门店管理'],
    desc: '统筹上下游资源，管控全链条物流、资金与信息流转',
  },
  {
    name: '计划',
    route: 'production-planning',
    tags: ['销售与运营计划', '物料需求计划', '主生产计划', '高级计划排程'],
    desc: '制定产销与资源计划，统筹业务目标及执行安排',
  },
  {
    name: '生产',
    route: 'manufacturing',
    tags: ['生产', '质量', '工厂维护'],
    desc: '管控生产流程、物料与工序，保障生产有序高效',
  },
  {
    name: '项目',
    route: 'project-management',
    tags: ['项目管理'],
    desc: '追踪项目进度、资源与任务，把控项目交付质量',
  },
  {
    name: '财务',
    route: 'finance',
    tags: ['业财', '管理会计', '财务会计'],
    desc: '核算账务、管理财务，出具报表并提供财务决策分析',
  },
  {
    name: '人力',
    route: 'hcm',
    tags: ['核心人事', '招聘', '薪酬', '绩效'],
    desc: '管理员工全周期发展、薪酬绩效，支撑人力资源运营',
  },
];

export default function Collaboration() {
  const { isPc } = usePlatform() || {};
  return (
    <div className="aip-collaboration">
      <div className="aip-collaboration-grid">
        {collaborationItems.map((item) => {
          const imgSrc = `${ossPrefix}${item.name}.png`;
          const href = `/aip/product/${item.route}`;
          return (
            <div key={item.name} className="aip-collaboration-cell">
              <a href={href} target="_blank" rel="noopener noreferrer" className="aip-collaboration-item">
                <img className="aip-collaboration-bg" src={imgSrc} alt={item.name} loading="lazy" />
                <div className="aip-collaboration-content">
                  <div className="aip-collaboration-title">{item.name}</div>
                  {isPc && item.tags?.length ? (
                    <div className="aip-collaboration-tags">
                      {item.tags.map((t) => (
                        <span key={t} className="aip-collaboration-tag">
                          {t}
                        </span>
                      ))}
                    </div>
                  ) : null}
                </div>
                {isPc && item.desc ? (
                  <div className="aip-collaboration-desc-wrapper">
                    <div className="aip-collaboration-desc">{item.desc}</div>
                  </div>
                ) : null}
              </a>
            </div>
          );
        })}
      </div>
    </div>
  );
}